import { Headline } from './Headline'
import { Container } from './Container'
import { Column, Grid } from './Grid'
import ellipse from '@/public/images/ellipse.png'
import Image from 'next/image'
import { CheckMark } from './CheckMark'
import { CrossMark } from './CrossMark'
import { imageLoader } from '@/loaders/index'

export function BlackSectionTwo({
  className = ''
}) {
  return (
    <section className={`${className} bg-black`} id="whos-this-for">
      <Container>
        <Grid className="py-[90px] md:py-[106px] justify-between relative text-white flex-col md:flex-row">
          <Column className="md:w-[20%]">
            <Headline tag="h2" color="white" className="text-[40px] mb-[60px] md:mb-0 md:text-[56px] leading-[1.1]">Who Is <br/> This <span className='font-accent font-thin text-[48px] md:text-[60px]'>For</span>?</Headline>
          </Column>
          <Column className="md:w-[40%] md:ml-[40px] max-w-[350px] mb-[60px] md:mb-0">
            <Headline tag="h3" color="white" className="text-[24px] md:text-[34px] leading-[1.1]">You’re <span className="underline">a good</span> fit if…</Headline>
            <ul>
              <li className="flex mt-[30px]"><CheckMark className="mr-[18px] mt-[4px]"/> You have control over how you spend your time, and you want to make as much impact as possible.</li>
              <li className="flex mt-[30px]"><CheckMark className="mr-[18px] mt-[4px]"/> You struggle with focus and discipline and want the psychological tools to take action on autopilot.</li>
              <li className="flex mt-[30px]"><CheckMark className="mr-[18px] mt-[4px]"/> You have a cash flowing business that will earn more if you make smarter choices and execute on your most important work.</li>
              <li className="flex mt-[30px]"><CheckMark className="mr-[18px] mt-[4px]"/> You’re always busy but still feel stuck and need a method to find and focus on your 10x opportunities in business.</li>
              <li className="flex mt-[30px]"><CheckMark className="mr-[18px] mt-[4px]"/> You understand that this course is a powerful tool, but you will need to use it to get results.</li>
            </ul>
          </Column>
          <Column className="md:w-[40%] max-w-[360px]">
            <Headline tag="h3" color="white" className="text-[24px] md:text-[34px] leading-[1.1]">You’re <span className="underline">not a good</span> fit if…</Headline>
            <ul>
              <li className="flex mt-[30px]"><CrossMark className="mr-[18px] mt-[4px]"/> You don’t have control over your own time or do not choose your own priorities for what to work on.</li>
              <li className="flex mt-[30px]"><CrossMark className="mr-[18px] mt-[4px]"/> You want to obsess over making an over-optimized calendar or plan that you will give up in two weeks.</li>
              <li className="flex mt-[30px]"><CrossMark className="mr-[18px] mt-[4px]"/> You can’t earn at least 10x the price of this course in the next month by making smarter choices and actions as an entrepreneur.</li>
              <li className="flex mt-[30px]"><CrossMark className="mr-[18px] mt-[4px]"/> You’re expecting this to be a technical manual on project management tools like Asana or BaseCamp etc.</li>
              <li className="flex mt-[30px]"><CrossMark className="mr-[18px] mt-[4px]"/> You just want to learn interesting information, but won’t apply what you learn in practice.</li>
            </ul>
          </Column>
          <div className="absolute top-0 left-0 w-[850px] z-[-1]">
            <Image
              src={ellipse}
              alt="Ellipse decor"
              loader={imageLoader}
            />
          </div>
        </Grid>
      </Container>
    </section>
  )
}
